import { useAppSelector } from 'app/store';
import { ROLE_TENANT_SUPPLIER } from './../../constants';

export function isSupplier(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.includes(ROLE_TENANT_SUPPLIER) ?? false;
}
